import FooterIcetex from '../../components/footerIcetex/footerIcetex';
import HeaderIcetex from '../../components/headerIcetex/headerIcetex';
import { ILayout } from '../../../shared/types/layout';

export function LayoutPrevisora({ children }: ILayout) {
    return (
        <div>
            <HeaderIcetex />
            {children}
            <FooterIcetex />
        </div>
    );
}
